const firebaseConfig = {
    apiKey: "AIzaSyApGogJLIB-vqUfUsKOsfrG7xitdjmO7n0",
    authDomain: "digi-invite.firebaseapp.com",
    projectId: "digi-invite",
    storageBucket: "digi-invite.appspot.com",
    messagingSenderId: "184948832338",
    appId: "1:184948832338:web:1671d0ecefa649f433c78b",
    measurementId: "G-KYPWPBCQ3T"
}

export default firebaseConfig;